/**
 * Enum para tipos de remessa
 * Contém todos os possíveis tipos de remessas com seus IDs e descrições
 */
export const REMESSA_TYPES = {
  BOLETO: { id: 1, description: 'Boleto' },
  VINDI_BOLETO: { id: 2, description: 'Vindi - Boleto' },
  VINDI_CARTAO_CREDITO: { id: 3, description: 'Vindi - Cartão Crédito' },
  CELESC: { id: 4, description: 'Celesc' },
  DEBITO_AUTOMATICO: { id: 5, description: 'Débito Automático' },
  CANCELAMENTO_DEBITO_AUTOMATICO: { id: 6, description: 'Cancelamento Débito Automático' },
  CERGRAL: { id: 7, description: 'Cergral' },
  BOLETO_BRADESCO: { id: 8, description: 'Boleto Bradesco' },
  BOLETO_SICOOB: { id: 9, description: 'Boleto Sicoob' },
  BOLETO_SANTANDER: { id: 10, description: 'Boleto Santander' },
  BOLETO_ITAU: { id: 11, description: 'Boleto Itaú' },
  BOLETO_CAIXA: { id: 12, description: 'Boleto Caixa' },
  CARNE: { id: 13, description: 'Carnê' },
  BOLETO_SICREDI: { id: 14, description: 'Boleto Sicredi' },
  CNAB_400: { id: 15, description: 'Boleto Cnab 400' },
  // PHOENIX-977: tipo 17 do back (TipoRemessaFinanceira.BOLETO_BB); a listagem ja o mostrava, aqui faltava
  BOLETO_BB: { id: 17, description: 'Boleto Banco do Brasil' },
  A_DEFINIR: { id: 99, description: 'A Definir' },
}

/**
 * Funções auxiliares para tipos de remessa
 */
export const RemessaTypeUtils = {
  /**
   * Retorna o objeto de tipo de remessa pelo ID
   * @param {number} id - O ID do tipo de remessa
   * @returns {Object|null} O objeto do tipo de remessa ou null se não encontrado
   */
  getById: (id) => {
    return Object.values(REMESSA_TYPES).find((type) => type.id === id) || null
  },

  /**
   * Retorna a descrição de um tipo de remessa pelo ID
   * @param {number} id - O ID do tipo de remessa
   * @returns {string} A descrição ou "Desconhecido" se não encontrado
   */
  getDescriptionById: (id) => {
    const type = RemessaTypeUtils.getById(id)
    return type ? type.description : 'Desconhecido'
  },

  /**
   * Verifica se um tipo de remessa suporta sincronização
   * @param {number} id - O ID do tipo de remessa
   * @returns {boolean} Verdadeiro se o tipo suporta sincronização
   */
  supportsSynchronization: (id) => {
    // Todos os tipos exceto VINDI_BOLETO e VINDI_CARTAO_CREDITO suportam sincronização
    return id !== REMESSA_TYPES.VINDI_BOLETO.id && id !== REMESSA_TYPES.VINDI_CARTAO_CREDITO.id
  },

  /**
   * Verifica se um tipo de remessa suporta download
   * @param {number} id - O ID do tipo de remessa
   * @returns {boolean} Verdadeiro se o tipo suporta download
   */
  supportsDownload: (id) => {
    // Tipos que suportam download
    const downloadTypes = [
      REMESSA_TYPES.BOLETO.id,
      REMESSA_TYPES.CELESC.id,
      REMESSA_TYPES.DEBITO_AUTOMATICO.id,
      REMESSA_TYPES.CANCELAMENTO_DEBITO_AUTOMATICO.id,
      REMESSA_TYPES.CERGRAL.id,
      REMESSA_TYPES.CNAB_400.id,
    ]
    return downloadTypes.includes(id)
  },

  /**
   * Verifica se um tipo de remessa suporta reprocessamento
   * @param {number} id - O ID do tipo de remessa
   * @returns {boolean} Verdadeiro se o tipo suporta reprocessamento
   */
  supportsReprocessing: (id) => {
    const reprocessingTypes = [
      REMESSA_TYPES.BOLETO.id,
      REMESSA_TYPES.VINDI_BOLETO.id,
      REMESSA_TYPES.BOLETO_BRADESCO.id,
      REMESSA_TYPES.BOLETO_SICOOB.id,
      REMESSA_TYPES.BOLETO_SANTANDER.id,
      REMESSA_TYPES.BOLETO_ITAU.id,
      REMESSA_TYPES.BOLETO_CAIXA.id,
      REMESSA_TYPES.BOLETO_SICREDI.id,
      REMESSA_TYPES.CNAB_400.id,
      REMESSA_TYPES.BOLETO_BB.id,
    ]
    return reprocessingTypes.includes(id)
  },
}
